/** Numbers as the reader's language writes them (Sprint 103.0). */

import type { Language } from '../i18n/i18n.ts';

export function degrees(value: number, language: Language, fractionDigits = 0): string {
  return new Intl.NumberFormat(language, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  }).format(value);
}

/** `+01:00`, `-03:30`: what follows UTC in a zone line. */
export function utcOffset(minutes: number): string {
  const sign = minutes < 0 ? '-' : '+';
  const whole = Math.abs(minutes);
  return `${sign}${String(Math.floor(whole / 60)).padStart(2, '0')}:${String(whole % 60).padStart(2, '0')}`;
}

/** An angle brought into [0, 360). */
export function wrapDegrees(value: number): number {
  return ((value % 360) + 360) % 360;
}
